import React from 'react'
import get from 'lodash/get'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import * as Actions from '../redux/actions'
import { _t, useClass } from '../lib/utils'

class Display extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    const p = this.props
    const schema = get(p, 'schema')
    const locale = get(p, 'locale')
    const title = get(p, 'schema.title')
    const classes = get(p, 'schema.classes')
    let content = get(schema, 'content', '')
    let dataKey = get(schema, 'data', '')
    let dataValue = get(p.appxigonState, dataKey, '')
    // TODO: should distinguish data vs value ?
    // content is the formatting template of display data
    content = content.replace('\%s', _t(dataValue))
    return (
      <div className={useClass(
                classes,
                {hidden: !p.show}
              )
            }
      >
        { _t(title) }
        { content }
        { p.value }
        {
          // this.state.schema && this.state.schema.type
          // ? `Display: ${this.state.schema.type} (${this.state.id})`
          // : `Display: (${this.state.id})`
        }
      </div>
    )
  }
}

function mapStateToProps(s, p) {
  console.info(`value: ${get(s, ['AXGState', p.AXGKey])}`)
  return {
    appxigonState: s.AXGState,
    value: get(s, ['AXGState', p.AXGKey])
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Display)



// WEBPACK FOOTER //
// ./item-types/display.js